import { type ComponentProps } from 'react'

import { FormControl } from './form'
import * as Select from '../select'

const FormSelectRoot = (props: ComponentProps<typeof Select.Root>) => {
  return (
    <FormControl>
      <Select.Root {...props} />
    </FormControl>
  )
}

const FormSelectTrigger = (props: ComponentProps<typeof Select.Trigger>) => {
  return (
    <FormControl>
      <Select.Trigger {...props} />
    </FormControl>
  )
}

export { FormSelectRoot, FormSelectTrigger, Select }
